import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { CxC } from './cxc';

@Injectable({
  providedIn: 'root'
})
export class CuentasxcobrarService {

  
  constructor(private http: HttpClient) { }
  setActulizar(lista: CxC[]){
    console.log(lista);
    return this.http.put<string>(environment.apiUrl+"/actulizarCuentasCobrar/",lista);
  }
  

  cuentaxCobrar(id: string) {  
    
    return this.http.get<CxC>(environment.apiUrl+"/obtenerCXC/?id=" + id);  
  }  

  getCuentasxCobrar(id: string) {  
    
    return this.http.get<CxC[]>(environment.apiUrl+"/listaCuentasCobrar/?id=" + id);  
  }  
  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarCuentasCobrar/?id="+id);
  }
  
}
